// extracted by mini-css-extract-plugin
module.exports = {"header_chart":"ChartActivePower_header_chart__2zFcb","chart":"ChartActivePower_chart__2em_m","chart_report":"ChartActivePower_chart_report__19RPN"};